import { ActivatedRoute, Router } from '@angular/router';
import { Transaction } from './../../dto/transaction/transaction';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs } from 'file-saver';
import { MatSort, Sort } from '@angular/material/sort';
import { ExportService } from '../../service/export.service';
import { SpinnerService } from '../../service/spinner.service';
import { HttpPaginatedDataSource } from '../../utils/HttpPaginatedDataSource';
import { TransactionService } from '../../service/transaction.service';
import { StatusTransaction } from '@/enum/statusTransaction';
import { ClientService } from '../../service/client.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../service/authentication.service';
import { Role } from '../../enum/role';

@Component({
    selector: 'app-transaction',
    templateUrl: './transaction.page.html',
    styleUrls: ['./transaction.page.scss']
})
export class TransactionPage implements OnInit, OnDestroy {
    FilterForm: FormGroup;
    exportForm: FormGroup;
    public data: HttpPaginatedDataSource<any>;
    public pageIndex = 1;
    public pageSize: number;
    public pageSizeOpts: number[];
    public listCustomer: any[] = [];
    public sortCol = "creation_date";
    public sortDir = "desc";
    public StatusTransaction: typeof StatusTransaction = StatusTransaction;
    private cart_id: string;
    public canSeeFullExport: boolean;
    public isExporting: boolean = false;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('selectOption') selectOption: any;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    private unsubscribe: Subscription[] = [];
    constructor(private router: Router, private routerParams: ActivatedRoute, private spinnerService: SpinnerService, private exportService: ExportService, private transactionService: TransactionService, private formBuilder: FormBuilder,
        private clientService: ClientService, private translateService: TranslateService, private authenticationService: AuthenticationService) {
        routerParams.params.subscribe(val => {
            this.handleCorresponding()
        });

        this.canSeeFullExport = this.authenticationService.currentUserValue.role === Role.AdminBPS || this.authenticationService.currentUserValue.role === Role.Admin;
    }

    public columnsToDisplay = ['transaction_id', 'customer', 'barcode', 'amount', 'status', 'bank_id', 'creation_date'];

    handleCorresponding() {
        this.cart_id = this.routerParams.snapshot.queryParams['cartid'];
        this.filterForm()
    }

    reset() {
        this.FilterForm.reset();
        this.cart_id = "";
        this.selectOption.nativeElement.setAttribute('placeholder', this.translateService.instant('Transaction.Text.SelectOne'))
        this.FilterForm.patchValue({
            client__id: ""
        })
    }

    ngOnInit() {
        this.unsubscribe.push(
            this.clientService.get().pipe(finalize(() => {
            })).subscribe(val => {
                this.listCustomer = val;
            })
        );

        this.data = new HttpPaginatedDataSource([]);
        this.data.sort = this.sort;
        this.data.paginator = this.paginator;
        this.pageSizeOpts = [5, 10, 15, 20, 100]
        this.pageSize = 15;
        this.pageIndex = 0;

        this.FilterForm = this.formBuilder.group({
            trx_id: [''],
            user_id: [''],
            bank_id: [''],
            barcode: [''],
            client_reference: [''],
            customer: [''],
            status: [''],
            minAmount: [''],
            maxAmount: [''],
            minDate: [''],
            maxDate: [''],
            client__id: ['']
        });

        this.handleCorresponding()

        this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);

        this.exportForm = this.formBuilder.group({
            typeExport: 'csv'
        })

        this.sort.sortChange.subscribe((sort: Sort) => {
            this.paginator.pageIndex = 0;
            this.pageIndex = 0;
            this.sortCol = sort.active;
            if (this.sortCol === "transaction_id")
                this.sortCol = 'trx_id';
            else if (this.sortCol === "customer")
                this.sortCol = "client";
            this.sortDir = sort.direction;
            this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
        });
    }

    get f() { return this.FilterForm.controls; }

    handleExport() {
        this.isExporting = true;
        let typeForm = this.exportForm.controls.typeExport.value
        this.unsubscribe.push(this.exportService.getExportTransaction(typeForm, this.CreateDataFilter(), this.sortCol, this.sortDir).pipe(finalize(() => {
            this.spinnerService.hide();
            this.isExporting = false;
        })).subscribe(data => { saveAs(data, 'transaction.' + typeForm) }))
    }

    // SELECT OPTION CUSTOMER
    handleChangeCustomer(e) {
        let txt_placeholder = e.target.value || ''
        this.selectOption.nativeElement.value = ''
        this.FilterForm.patchValue({
            client__id: txt_placeholder
        })
        this.selectOption.nativeElement.setAttribute('placeholder', txt_placeholder)
    }

    goToDetails(path) {
        this.router.navigate(['/transaction/' + path])
    }

    onSubmit(pageSize: number, pageIndex: number, dataFilter: Transaction, sortCol: string, sortDir: string) {
        this.spinnerService.show();

        this.unsubscribe.push(
            this.transactionService.get(pageIndex, pageSize, dataFilter, sortCol, sortDir).pipe(finalize(() => {
                this.spinnerService.hide();
            })).subscribe(val => {
                this.data.data = val.data
                this.data.sort = this.sort;
                this.data.sortingDataAccessor = (item, property) => {
                    if (property === 'status') {
                        let text = this.translateService.instant(StatusTransaction[item[property]]);
                        return text.toLocaleLowerCase();
                    } else if (typeof item[property] === 'string') {
                        return item[property].toLocaleLowerCase();
                    } else {
                        return item[property];
                    }
                };

                this.data._updatePaginator(val.total)
            })
        );
    }

    private CreateDataFilter(): Transaction {
        const data = new Transaction();
        data.trx_id = this.f.trx_id.value;
        data.user_id = this.f.user_id.value;
        data.bank_id = this.f.bank_id.value;
        data.barcode__icontains = this.f.barcode.value;
        data.client_id = this.parseValueFromCustomerInput(this.f.client__id.value);
        data.client_reference = this.f.client_reference.value;
        data.status = this.f.status.value;
        data.amount = '';
        data['amount__gte'] = this.f.minAmount.value;
        data['amount__lte'] = this.f.maxAmount.value;
        data.creation_date = '';

        if(this.f.minDate.value) {
            const startOfDay = new Date(this.f.minDate.value);
            startOfDay.setUTCHours(0, 0, 0, 0);
            data['creation_date__gte'] = this.f.minDate.value ? startOfDay.toISOString() : "";
        }

        if(this.f.maxDate.value) {
            const endOfDay = new Date(this.f.maxDate.value);
            endOfDay.setUTCHours(23, 59, 59, 999);

            data['creation_date__lte'] = this.f.minDate.value ? endOfDay.toISOString() : "";
        }

        data.cart_id = this.cart_id;
        data["lang"] = this.translateService.currentLang;
        return data;
    }

    change(pageEvent: PageEvent) {
        if (this.pageIndex !== pageEvent.pageIndex || this.pageSize !== pageEvent.pageSize) {
            this.pageIndex = pageEvent.pageIndex;
            this.pageSize = pageEvent.pageSize;
            this.data = new HttpPaginatedDataSource([]);
            this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
        }
    }

    parseValueFromCustomerInput(value: string) {
        for (let i = 0; i < this.listCustomer.length; i++) {
            if (this.listCustomer[i].text == value) return this.listCustomer[i].id
        }
        return ""
    }

    filterForm() {
        this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(s => s.unsubscribe());
    }
}
